<ng-container *transloco="let t">
  @if (label) {
  <label>{{ label }}

    @if (errors?.['required']) {
    <small>*</small>
    }
  </label>
  }
  <app-dropdown (dropdownClosed)="dropdownClosed($event)" [disabled]="disabled">
    <div dropdownPanel>
      <div class="form-control input-wrapper d-flex align-items-center" [ngClass]="{
          'error':  touched && invalid,
          'disabled': disabled,
          'ng-touched': touched,
          'ng-invalid ': touched && invalid
      }">
        <div class="form-floating">
          <div class="input-group">
            <div class="d-flex align-items-center" dropdownToggle>
              <div class="dropdown-button d-flex align-items-center">
                @if (selectedCountry) {
                @if (selectedCountry.isoCode) {
                <span [class]="'fi fi-'+selectedCountry.isoCode.toLowerCase()" style="scale: 80%"></span>
                }
                <span class="ps-1 pe-1">
                  {{ selectedCountry.callCode }}
                </span>
                } @else {
                }
              </div>
            </div>
          </div>
        </div>
        <input class="number-input ps-2 me-0 pe-0 flex-grow-1 d-flex" [disabled]="disabled"
          [placeholder]="numberPlaceholder" [ngModel]="localNumber" (ngModelChange)="onNumberInput($event)" />
      </div>
    </div>
    <div dropdownContent>
      <div class="px-0 mx-0 search-wrapper">
        <div class="d-flex align-items-center p-0 m-0 px-4 pt-2">
          <i class="bi bi-search ps-1"></i>
          <input [placeholder]="searchPlaceholder ?? t('explore.search')" class="search-input ps-2 d-flex"
            [ngModel]="searchText" (ngModelChange)="onSearch($event)" />
        </div>
      </div>
      <div class="scrollable-list">
        <ul class="countries-list px-0 mx-0 pb-2">
          @if (filteredCountries.length > 0) {
          @for (country of filteredCountries;track country;let idx = $index) {
          <li (click)="selectCountry(country)" dropdownItem
            class="d-flex align-items-center p-0 m-0 px-4 pt-2 justify-content-between" [ngClass]="{'pt-0': idx === 0}">
            <div class="d-flex justify-content-start align-items-center">
              <div>
                @if (country.isoCode) {
                <span [class]="'fi fi-' + country.isoCode.toLowerCase()" style="scale: 80%"></span>
                }
              </div>
              <div class="ps-2">
                <span>{{ country.name }}</span>
                <span class="ps-2"> ({{ country.callCode }})</span>
              </div>
            </div>

            @if (country.id === selectedCountry?.id) {
            <span><i class="bi bi-check2"></i> </span>
            }
          </li>
          }
          } @else {
          <li class="d-flex align-items-center p-0 m-0 px-4 pt-2"> {{ t("emptyState.not.able.to.find") }}
          </li>
          }
        </ul>
      </div>
    </div>
  </app-dropdown>
  @if (touched) {
  @for(errorMessage of errors | errorMessages; track errorMessage){
  <span class="errorMes pt-1">{{ errorMessage }} </span>
  }
  }
</ng-container>